
export const allowedContentTypes = (content) => {
  const includeContentType = ['product', 'sku'];
  return includeContentType.includes(content);
};
